import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment.dev';
import { Auth } from './auth.service';

export interface NamedAmount {
  name: string;
  amount: number;
  count: number;
}

export interface FinanceBoletas {
  cantidadBoletas: number;
  cantidadSinEnviar: number;
  totalEmitido: number;
  totalIgv: number;
}

export interface FinanceSeries {
  labels: string[];
  cobrado: number[];
  pedidosCreados: number[];
}

export interface FinanceStats {
  cobradoWeb: number;
  cobradoWebCount: number;
  comisionMp: number;
  netoWeb: number;
  comisionMpPct: number;
  porCobrar: number;
  porCobrarCount: number;
  embudoPendientes: number;
  embudoAprobados: number;
  embudoRechazados: number;
  tasaAprobacion: number;
  mixMetodo: NamedAmount[];
  mixCanal: NamedAmount[];
  ticketPromedioWeb: number;
  ticketPromedioManual: number;
  ticketWebCount: number;
  ticketManualCount: number;
  boletas: FinanceBoletas;
  serieTemporal: FinanceSeries;
  from: string;
  to: string;
}

@Injectable({ providedIn: 'root' })
export class FinanceService {
  private apiUrl = `${environment.apiUrl}/finance`;

  constructor(private http: HttpClient, private auth: Auth) {}

  getStats(from?: string, to?: string): Observable<FinanceStats> {
    const token = this.auth.getToken();
    const headers = new HttpHeaders({ Authorization: `Bearer ${token}` });
    let params = new HttpParams();
    if (from) params = params.set('from', from);
    if (to) params = params.set('to', to);
    return this.http.get<FinanceStats>(`${this.apiUrl}/stats`, { headers, params });
  }
}
